import { render, staticRenderFns } from "./puppy-for-sale-details.vue?vue&type=template&id=a4054a64&scoped=true&lang=pug"
import script from "./puppy-for-sale-details.js?vue&type=script&lang=js&external"
export * from "./puppy-for-sale-details.js?vue&type=script&lang=js&external"
import style0 from "./puppy-for-sale-details.vue?vue&type=style&index=0&id=a4054a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4054a64",
  null
  
)

export default component.exports